import React from 'react';
import { DraggableCore } from 'react-draggable';
import { Rnd } from 'react-rnd';
import * as S from '@styles/chat/chat.style';
import { CHAT_POPUP_CLASSNAME, CHAT_ROOM_REM_WIDTH, POPUP_DRAG_CANCEL_CLASSNAME, POPUP_DRAG_HANDLE_CLASSNAME, RESIZABLE_CHAT_ELEMENT_CLASSNAME } from 'constants/chat';
import _ from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
const ChatPopupWrapper = ({
  draggableCoreProps,
  popupRef,
  defaultPosition,
  rndProps,
  children
}) => {
  const popupRndPropsDefaultValues = {
    resizeHandleStyles: {
      right: {
        cursor: 'ew-resize'
      },
      bottom: {
        cursor: 'ns-resize'
      },
      bottomRight: {
        cursor: 'nwse-resize'
      }
    },
    className: `z-[99] w-fit !flex flex-col bg-my-gray-100 rounded-xl overflow-hidden border border-solid border-my-gray-70 !transform-none ${RESIZABLE_CHAT_ELEMENT_CLASSNAME}`,
    style: {
      boxShadow: '0px 8px 24px 0px rgba(23, 32, 42, 0.16)'
    },
    minWidth: CHAT_ROOM_REM_WIDTH * 16,
    maxWidth: typeof window !== 'undefined' ? window.innerWidth / 2 : 0,
    minHeight: typeof window !== 'undefined' ? window.innerHeight / 100 * 60 : 0,
    maxHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
    disableDragging: true,
    default: {
      x: null,
      y: null,
      height: CHAT_ROOM_REM_WIDTH * 16,
      width: null
    }
  };
  return /*#__PURE__*/_jsx(DraggableCore, {
    ...draggableCoreProps,
    cancel: POPUP_DRAG_CANCEL_CLASSNAME,
    handle: POPUP_DRAG_HANDLE_CLASSNAME,
    children: /*#__PURE__*/_jsx(S.ChatPopup, {
      className: CHAT_POPUP_CLASSNAME,
      ref: popupRef,
      top: !_.isNil(defaultPosition.y) ? defaultPosition.y : null,
      left: !_.isNil(defaultPosition.x) ? defaultPosition.x : null,
      children: /*#__PURE__*/_jsx(Rnd, {
        ...popupRndPropsDefaultValues,
        ...rndProps,
        children: children
      })
    })
  });
};
export default ChatPopupWrapper;